<template>
  <div>
    <p class="title" v-if="showAvailableCoupons.length">{{couponsTitle}}</p>
    <transition name="fade">
      <div v-if="hasCoupon">
        <transition-group name="fade" tag="div">
          <soda-coupon-cell
            @couponModelCk="couponModelCkFn(coupon,index)"
            class="coupon-content"
            v-for="(coupon, index) in showAvailableCoupons"
            :key="index+`type${couponBusinessType}`"
            :country="country"
            :index="index"
            :from="3"
            :backgroundColor="bannerData.backgroundColor"
            :selectable="false"
            :couponSrc="coupon">
          </soda-coupon-cell>
        </transition-group>
        <div v-if="availableCoupons.length>2">
          <!-- 下一页 -->
          <div class="coupon-more coupon-next"
            ontouchstart=""
            v-show="isMore"
            @click="handleMore()">
            {{gettext('查看更多')}}<i class="c-common_icon_spread"></i>
          </div>
          <!-- 展开 -->
          <div class="coupon-more coupon-down"
            ontouchstart=""
            v-show="isDown"
            @click="handleDown()">
            {{gettext('查看更多')}}<i class="c-common_icon_spread"></i>
          </div>
          <!-- 收起 -->
          <div class="coupon-more coupon-up"
            ontouchstart=""
            v-show="isUp"
            @click="handleUp()">
            {{gettext('收起')}}<i class="c-common_icon_spread"></i>
          </div>
        </div>
      </div>
    </transition>
    <!-- <div v-if="!hasCoupon" class="coupon-empty-text">{{_('暂无优惠券')}}</div> -->
    <loading-mask v-show="getCouponloading"></loading-mask>
  </div>
</template>

<script>
import Interrupt from '@/components/interrupt'
import LoadingMask from '@/components/loading/loading-mask'
import * as api from '@/api/newCouponsCenter/index'
import { getLanguageLong } from '@didi/gettext'
import { couponModelSw, couponMoreCk, conpouRealexposureSw, couponModelCk } from '../../track'

export default {
  name: 'couponsList',
  props: {
    couponRid: {
      type: String,
      default: ''
    },
    bannerData: {
      type: Object,
      default: {
        type: {}
      }
    },
    // 0 平台券，1商家券
    couponBusinessType: {
      type: Number,
      default: 0
    }
  },
  components: {
    Interrupt,
    LoadingMask
  },
  data () {
    return {
      isInit: false,
      height: 0,
      couponData: [],
      size: 10,
      getCouponloading: false,
      isLoadMore: true, // 初始化展开true，查看更多、收起false
      currentPage: 1, // 标识当前展示券列表的第几页
      stopLoadingCoupon: false, // 停止翻页loading
      isLastPage: false // 标识是否已翻到最后一页
    }
  },
  computed: {
    country () {
      return this.$store.state.country
    },
    couponsTitle () {
      if (this.couponBusinessType === 0) {
        const brand = this.$store.state.brand === '99' ? '99' : 'DiDi'
        return this.$t('FoodC_Translation__brand_LAYp', {brand_name: brand})
      } else {
        return this.$t('FoodC_store_Store_Coupon_szoR')
      }
    },
    // 收起
    isUp () {
      return !this.isLoadMore && this.isLastPage
    },
    // 展开
    isDown () {
      return this.isLoadMore
    },
    // 查看更多
    isMore () {
      return !this.isLoadMore && !this.isLastPage
    },
    hasCoupon () {
      return this.availableCoupons.length !== 0
    },
    availableCoupons () {
      return this.couponData.filter(item => (+item.status === 2 && +item.isExpired === 0))
    },
    showAvailableCoupons: {
      get () {
        // 初始化和展开
        if (this.isLoadMore) {
          if (this.availableCoupons.length < 3) return this.availableCoupons
          return this.getThree()
        } else { // 查看更多和收起
          return this.availableCoupons
        }
      },
      set (val) {
        this.showAvailableCoupons = val
      }
    }
  },
  async mounted () {
    await this.getCouponList()
  },
  methods: {
    // 获取优惠券列表
    async getCouponList (page) {
      if (page && page > 1) this.getCouponloading = true
      if (!page || page === 1) this.couponData = []
      const params = {
        utc_offset: 0 - new Date().getTimezoneOffset(),
        expire_flag: 6,
        page: page || 1,
        lang: getLanguageLong(),
        size: this.size,
        couponBusinessType: this.couponBusinessType
      }
      const res = await api.getAllCoupons(params)
      this.isInit = true
      this.getCouponloading = false
      if (!res.errno) {
        const newCouponList = res.data.couponList
        this.isLastPage = res.data ? !res.data.next : true // 翻页标识：0标识没有下一页了，1标识还可以继续拉取下一页
        this.couponData = this.couponData.concat(newCouponList)
        this.stopLoadingCoupon = true
        // 用户有优惠券埋点
        if (newCouponList.length) {
          newCouponList.forEach((item, index) => {
            if (this.couponBusinessType === 0) {
              couponModelSw({
                coupon_id: item.couponId,
                coupon_type: item.couponBusinessType,
                index: index + (this.currentPage - 1) * 10
              })
            } else {
              conpouRealexposureSw({
                coupon_id: item.couponId,
                coupon_type: item.couponBusinessType,
                index: index + (this.currentPage - 1) * 10
              })
            }
          })
        }
      } else {
        const toast = this.$createToast({
          time: 3000,
          txt: this.gettext('网络不佳，请检查您的网络'),
          type: 'error'
        })
        toast.show()
      }
    },
    getThree () {
      let newArr = []
      for (var i = 0; i < 2; i++) {
        let item = this.availableCoupons[i]
        newArr.push(item)
      }
      return newArr
    },
    // 点击更多
    async handleMore () {
      await this.getCouponList(++this.currentPage)
      this.isLoadMore = false
      couponMoreCk()
    },
    // 收起
    handleUp () {
      this.isLoadMore = true
    },
    // 展开
    handleDown () {
      this.isLoadMore = false
      couponMoreCk()
    },
    couponModelCkFn (item, index) {
      couponModelCk({
        coupon_id: item.couponId,
        coupon_type: item.couponBusinessType
      })
    }
  }

}
</script>
<style scoped lang="scss">
  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active{
    transition: opacity .4s ease;
  }
  .fade-enter-to {
    opacity: 1;
  }
  .coupon-content{
    margin-bottom:20px;
    &:last-child{
      margin-bottom:0
    }
  }
  .coupon-more{
    font-family: 'Aspira Medium';
    font-size: 28px;
    color: #FFFFFF;
    text-align: center;
    margin: 48px 0 0 0;
    opacity: 1;
    i{
      color: #fff;
      margin-left: 8px;
      font-size: 16px;
      vertical-align: middle;
    }
  }
  .coupon-up{
    i{
      display: inline-block;
      transform: rotate(180deg);
    }
  }
  .coupon-more:active{
    opacity: .5;
  }
  .coupon-empty-text{
    margin-top: 38px;
    text-align: center;
    opacity: 0.5;
    font-family: 'Aspira Medium';
    font-size: 28px;
    color: #FFFFFF;
  }
  .mask{
    left: 50%;
    top: 50%;
    background-color: #ffffff;
    transform: translate(-50%, -100%);
    width: 60px;
    height: 32px;
    border-radius: 8px;
    padding: 18px 40px 38px 40px;
    box-shadow: 0 16px 80px rgba(0,0,0,.16);
  }
  .title{
    font-family: 'Aspira Medium';
    font-size: 48px;
    color: #FFFFFF;
    margin:88px 0 32px 0;
  }
</style>
